import React, { useState } from "react";
import { Alert, Button, Card, Form, Spinner } from "react-bootstrap";
import { apiClient } from "../../api/client";
import { useAuth } from "../providers/AuthProvider";

/**
 * ChangePasswordGate — full-screen forced password rotation.
 *
 * Rendered by AppLayout instead of the normal shell whenever the authenticated
 * user has must_change_password=true (teacher accounts created by an OWNER with
 * a temporary password). The user cannot reach any other route until they set a
 * new password.
 */
function ChangePasswordGate() {
  const { user, markPasswordChanged } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (next !== confirm) {
      setError("Las contraseñas nuevas no coinciden.");
      return;
    }
    if (next.length < 8) {
      setError("La nueva contraseña debe tener al menos 8 caracteres.");
      return;
    }

    setSubmitting(true);
    try {
      await apiClient.post("/api/v1/users/change-password/", {
        current_password: current,
        new_password: next,
      });
      markPasswordChanged();
    } catch (err) {
      const data = err?.response?.data;
      const msg =
        data?.current_password?.[0] ??
        data?.new_password?.[0] ??
        data?.detail ??
        "No se pudo cambiar la contraseña. Inténtalo de nuevo.";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", background: "#f4f5fa", padding: "1rem" }}
    >
      <Card style={{ maxWidth: 440, width: "100%" }}>
        <Card.Body className="p-4">
          <h4 className="mb-1">Cambia tu contraseña</h4>
          <p className="text-muted small mb-4">
            {user?.name ? `Hola ${user.name}. ` : ""}
            Por seguridad, debes establecer una contraseña nueva antes de
            continuar.
          </p>

          {error && (
            <Alert variant="danger" className="py-2">
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium">Contraseña temporal</Form.Label>
              <Form.Control
                type="password"
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                autoComplete="current-password"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium">Nueva contraseña</Form.Label>
              <Form.Control
                type="password"
                value={next}
                onChange={(e) => setNext(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="fw-medium">
                Confirmar nueva contraseña
              </Form.Label>
              <Form.Control
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
              />
            </Form.Group>
            <Button
              type="submit"
              variant="primary"
              className="w-100"
              style={{ minHeight: 44 }}
              disabled={submitting}
            >
              {submitting ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Guardar y continuar"
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export { ChangePasswordGate };
